<template>
  <section
    class="bg-gradient-to-r from-gray-100/70 to-gray-100 relative py-16 sm:py-24"
  >
    <div class="absolute top-0 inset-x-0 hidden sm:block">
      <img
        src="/assets/images/shapes/white-wave.svg"
        alt="svg"
        class="w-full -scale-x-100"
      />
    </div>

    <div class="py-5">
      <div class="container relative">
        <div class="text-center">
          <h1 class="text-3xl/tight font-medium mb-4">Fiyatlandırma</h1>
          <p class="text-gray-500"></p>
        </div>

        <div class="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-7 mt-14">
          <pricing-single-box
            v-for="(packagex, index) in packageStore.packages"
            :key="index"
            :packagex="packagex"
          />
        </div>
      </div>
    </div>

    <div class="absolute bottom-0 inset-x-0 hidden sm:block">
      <img
        src="/assets/images/shapes/white-wave.svg"
        alt="svg"
        class="w-full scale-x-100 -scale-y-100"
      />
    </div>
  </section>
</template>

<script setup>
import { usePackageStore } from "@/stores/packageStore";
import PricingSingleBox from "@/components/LandingLayout/landing-compoments/PricingSingleBox.vue";

const packageStore = usePackageStore();
</script>
